var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 5.2v-.64c0-.896 0-1.344-.175-1.686a1.6 1.6 0 0 0-.699-.7C11.984 2 11.536 2 10.64 2H9.36c-.896 0-1.344 0-1.687.174a1.6 1.6 0 0 0-.699.7c-.174.342-.174.79-.174 1.686v.64m1.6 4.4v4m3.2-4v4M2.8 5.2h14.4m-1.6 0v8.96c0 1.344 0 2.016-.262 2.53a2.4 2.4 0 0 1-1.049 1.048c-.513.262-1.185.262-2.53.262H8.24c-1.343 0-2.015 0-2.529-.262a2.4 2.4 0 0 1-1.049-1.048c-.261-.514-.261-1.186-.261-2.53V5.2",
    stroke: "#111927",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgDelete;